
import React, { useContext, useEffect, useRef, useState } from "react";
import "./SuccessComponent.css";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { set_image_upload_status } from "../../store/image_upload";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import FileContext from "../../context/Context";
import CloseIcon from '@mui/icons-material/Close';
import ProgressBar from "./ProgressBar";

const ProcessingVideo = () => {
    const { audit_id } = useParams();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [ratingSucceeded, setRatingSucceded] = useState(false);
    const [rating, setRating] = useState(0);
    const [qualityCheck, setQualityCheck] = useState(false);
    const [reportGeneration, setReportGeneration] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0); // New state for upload progress

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { capturedVideo } = useContext(FileContext);
    const { auditID } = useSelector((state) => state.imagesStore);

    const upload_video_to_azure = async (fileName, videoBlob) => {
        const videoType = videoBlob.type || 'video/mp4';

        const headers = {
            'Content-Type': videoType,
            'x-ms-blob-type': 'BlockBlob',
        };

        const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditVideos/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

        await axios.put(url, videoBlob, {
            headers,
            onUploadProgress: (progressEvent) => {
                const total = progressEvent.total;
                const current = progressEvent.loaded;
                const percentCompleted = Math.round((current * 100) / total);
                setUploadProgress(prevProgress => {
                    if (percentCompleted > prevProgress) {
                        return percentCompleted;
                    }
                    return prevProgress;
                });
            
                console.log(`Upload progress: ${percentCompleted}%`);
            }
        })
        .then(response => {
            if (response.status === 201) {
                console.log('Video uploaded successfully:', response.status);
                
            }
        })
        .catch(error => {
            console.error('Error uploading video:', error);
        });
    };
    useEffect(() => {
        let timer;
        if (uploadProgress === 100) {
            timer = setTimeout(() => {
                setQualityCheck(true);
            }, 1000);
        }
    
        // Cleanup function to clear the timeout
        return () => {
            clearTimeout(timer);
        };
    }, [uploadProgress]);
    
    useEffect(() => {
        const handleProceed = async () => {
            const fileName = `${audit_id}_video.mp4`;
            await upload_video_to_azure(fileName, capturedVideo[0]);
            try{
                const result2 = await axios.post("/create_audit/update_token", {
                    audit: audit_id,
                    processed: 1,
                    status:"processing"
                  });
            }
            catch(err){
                console.log(err,"error")
            }
        };

        handleProceed();
    }, [capturedVideo]);
	  
   console.log(capturedVideo,"68")
	
   
    const handleButtonClick = () => {
        setPopupOpen(true);
    };

    const handleClosePopup = () => {
        setPopupOpen(false);
    };

    const handleStarClick = (star) => {
        setRating(star)
		
    };
	const handleSubmit =()=>{
		setRatingSucceded(true)
	 
	}
		

    const check = `${process.env.PUBLIC_URL}/custom-icons/timer.png`;
    const timer = `${process.env.PUBLIC_URL}/inspection-images/check-icon.png`;
    const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`;
    const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`;;
    const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`;
    const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`;
    const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`;
    const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`;
	const close = `${process.env.PUBLIC_URL}/custom-icons/close.png`;
    const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`;
    const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`;
    const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`;



  
    return (
        <>
           <div className="success-container">
    <div className="illustration-section">
        <img src={success} alt="Success Illustration" />
    </div>
    <div className="content-section">
        <div className="check-icon">
            <img src={check} alt="Check Icon" />
        </div>
        <h2>Processing</h2>
        <p>We are processing the inspection. Keep the window open.</p>
        <ol className="steps-list">
            <li className="step">
                <span className="step-number-audit">
                    <img src={step1_pink} alt="Step 1" />
                </span>
                Quality Check
                <span className="vertical-line"></span>
                <br />
                <div className="progress-container">
                    <ProgressBar percentage={uploadProgress} />
                </div>
                {!qualityCheck && <span className="upload-status">Uploading</span>}
            </li>
            <li className="step">
                <span className="step-number-audit">
                    {qualityCheck ? (
                        <img src={step2_pink} alt="Step 2" />
                    ) : (
                        <img src={step2_grey} alt="Step 2" />
                    )}
                </span>
                Report Generation
                {/* {qualityCheck && !reportGeneration && (
                    <span>
                        <CircularProgress
                            sx={{ color: "#ff0088", width: "20px !important", height: "20px !important" }}
                        />
                    </span>
                )} */}
                <span className="vertical-line2"></span>
            </li>
            <li className="step disabled-step">
                <span className="step-number-audit">
                    {reportGeneration ? (
                        <img src={step3_pink} alt="Step 3" />
                    ) : (
                        <img src={step3_grey} alt="Step 3" />
                    )}
                </span>
                Report Submission
            </li>
        </ol>
    </div>
    <button className="rate-experience-btn" onClick={handleButtonClick}>
        <img src={star} alt="Star Icon" /> RATE EXPERIENCE
    </button>
</div>


            {isPopupOpen && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						
                        <div className="rating-heading"><h4>How was your experience?</h4></div>
						<p>Please share with us your feedback:</p>
                        <div className="rating-stars">
                            {[1, 2, 3, 4, 5].map(starIndex => (
                                <img
                                    key={starIndex}
                                    src={starIndex <= rating ? starFilled : starEmpty}
                                    alt={`Star ${starIndex}`}
                                    className="star-icon"
                                    onClick={() => handleStarClick(starIndex)}
                                />
                            ))}
                        </div>
						<button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.2rem",
            border: rating!=0 ? "1.5px solid #FF0083" : "1.5px solid #0000003D",
            padding: "0rem 1rem",
            backgroundColor: rating!=0 ? "#FF0083" : "#dcdcdc",
            color: rating!=0  ? "#ffffff" : "#0000003D", 
            borderRadius: "3px",
            opacity: "0.9",
            width:"100%",
			marginTop:"0.5rem"
		
          }}
		  disabled={rating!=0?false: true}
		  onClick={handleSubmit}
        >
          <p
            style={{
              fontSize: "0.9rem",
              fontFamily: "'Montserrat', sans-serif",
            //   color: "#FF0083",
			color: rating!=0  ? "#ffffff" : "#0000003D", 
              padding: "0.5rem",
              cursor: "pointer"
            }}
            
          >
			 
            Submit
          </p>
        </button>
						
                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
			{isPopupOpen && ratingSucceeded && (
                <div className="popup-overlay">
                    <div className="popup-content-after-rating">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						
                        <div className="rating-heading-completion"><h4>Thank you for sharing 
						your feedback</h4></div>
						<p style={{textAlign:"center"}}>We appreciate your input and will use it to improve our services.</p>
                       
						
                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default ProcessingVideo